import { createSlice } from "@reduxjs/toolkit";
import { CampaignDetail } from "../Apis/CampaignDetail";

export const CampaignDetailSlice = createSlice({
  name: "campaigndetail",
  initialState: {
    campaigndetail: null,
    authenticatingcampaigndetail: false,
    authenticated: false,
    isError: false,
    errors: null
  },
  reducers: {
    clearState: (state) => {
      state.campaigndetail = null;
      state.isError = false;
      state.authenticated = false;
      state.authenticatingcampaigndetail = false;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(CampaignDetail.fulfilled, (state, action) => {
      state.campaigndetail = action.payload;
      state.authenticated = false;
      state.authenticatingcampaigndetail = false;
      return state;
    });
    builder.addCase(CampaignDetail.pending, (state, action) => {
      state.authenticatingcampaigndetail = true;
      state.authenticated = true;
    });
    builder.addCase(CampaignDetail.rejected, (state, action) => {
      state.errors = action.errors || action.payload;
      state.authenticated = false;
      state.authenticatingcampaigndetail = false;
      state.isError = true;
      return state;
    });
  }
});

export const { clearState } = CampaignDetailSlice.actions;

export const CampaignDetailSelector = (state) => state.campaigndetail;
